import React, { useState, useContext } from 'react'
import { LayoutContext } from '../../layout/index.js'
import './newsletter.scss'

const SIGN_UP_URL = '/.netlify/functions/mailChimpAddSubscriber'

function MailChimp() {
  const { localization } = useContext(LayoutContext)
  const [email, setEmail] = useState('')
  const [statusCode, setStatusCode] = useState(0)
  const [errorDescription, setErrorDescription] = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    if (!email) return

    fetch(SIGN_UP_URL, {
      method: 'POST',
      body: JSON.stringify({ email })
    })
      .then(response => response.json())
      .then(json => {
        if (json.statusCode === 200) {
          setStatusCode(200)
          setErrorDescription('')
        } else if (json && json.status === 400) {
          setStatusCode(400)
          if (json.title === 'Member Exists') {
            setErrorDescription(`${email}${localization.subscriber_exists}`)
          } else {
            setErrorDescription(localization.error)
          }
        }
      })
      .catch(() => {
        setStatusCode(400)
        setErrorDescription(localization.error)
      })
      .finally(() => {})
  }

  return (
    <div className="newsletter">
      {statusCode === 200 && (
        <p className="newsletter__success larger" role="alert">
          {localization.subscribe_success}&nbsp;
          <span aria-hidden="true">🎉</span>
        </p>
      )}

      {statusCode !== 200 && (
        <React.Fragment>
          <h2 className="heading-2 heading-2--blue">
            {localization.subscribe}
          </h2>
          <p className="larger center">{localization.subscribe_text}</p>
          <form action={SIGN_UP_URL} method="post" onSubmit={handleSubmit}>
            <label htmlFor="email">{localization.email}</label>
            <input
              type="email"
              name="email"
              id="email"
              placeholder={localization.email}
              onChange={e => setEmail(e.target.value)}
            />
            <input
              type="submit"
              value={localization.subscribe_button}
              disabled={email ? '' : 'disabled'}
              className={`button ${email ? '' : 'button--disabled'}`}
            />
          </form>
        </React.Fragment>
      )}
      <p className="newsletter__error" role="alert">
        {errorDescription}
      </p>
    </div>
  )
}
export default MailChimp
